import { render } from "./open.vue?vue&type=template&id=4f1cdc14&scoped=true&ts=true"
import script from "./open.vue?vue&type=script&lang=ts"
export * from "./open.vue?vue&type=script&lang=ts"

import "./open.vue?vue&type=style&index=0&id=4f1cdc14&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1cdc14"]])

export default __exports__